import api from "../../../services/api";

export const fetchSocialStats = async () => {
    return await api.get("/social-media/stats");
};

export const fetchSocialPosts = async () => {
    return await api.get("/social-media/posts");
};
